var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPersonWalkingOutline = function SvgPersonWalkingOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 2.5a2.5 2.5 0 1 1 4.999 0 2.5 2.5 0 0 1-5 0M22 23a1 1 0 1 1-2 0 1 1 0 0 0-1-1H5c-.552 0-1 .449-1 1a1 1 0 0 1-2 0c0-1.654 1.346-3 3-3h4v-9a1 1 0 1 1 2 0v3h2.5c.827 0 1.5-.673 1.5-1.5v-3c0-.827-.673-1.5-1.5-1.5H9.366a2 2 0 0 1-1.291-.473L2.354 2.686a.999.999 0 1 1 1.29-1.526L9.367 6H13.5C15.43 6 17 7.57 17 9.5v3a3.5 3.5 0 0 1-2 3.149V20h4c1.654 0 3 1.346 3 3m-11-3h2v-4h-2z"
  })));
};
export default SvgPersonWalkingOutline;